export default __webpack_public_path__ + "static/media/client8.dec0a7e9.jpeg";